import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { PLEINE_LARGEUR, STACK_SCREEN_OPTIONS } from './screenOptions';
import { SUR_LE_WEB } from '../theme/tokens';
import { ProfileScreen } from '../screens/ProfileScreen';
import { SettingsScreen } from '../screens/SettingsScreen';
import { PersonalInfoScreen } from '../screens/PersonalInfoScreen';
import { PrivacyScreen } from '../screens/PrivacyScreen';
import { DataDeletionScreen } from '../screens/DataDeletionScreen';
import { TermsScreen } from '../screens/TermsScreen';
import { NotificationsSettingsScreen } from '../screens/NotificationsSettingsScreen';
import { NotificationsScreen } from '../screens/NotificationsScreen';
import { HelpScreen } from '../screens/HelpScreen';
import { AdminScreen } from '../screens/AdminScreen';
import { LicenceEcoleScreen } from '../screens/LicenceEcoleScreen';

export type ProfileStackParamList = {
  LicenceEcole: undefined;
  Profile: undefined;
  Notifications: undefined;
  Settings: undefined;
  PersonalInfo: undefined;
  Privacy: undefined;
  Terms: undefined;
  DataDeletion: undefined;
  NotificationsSettings: undefined;
  Help: undefined;
  Admin: undefined;
};

const Stack = createNativeStackNavigator<ProfileStackParamList>();

export function ProfileNavigator() {
  return (
    <Stack.Navigator screenOptions={STACK_SCREEN_OPTIONS}>
      {/* Profil et Réglages portent leur propre fond pleine largeur sur le web (ProfilLarge,
          ParametresLarge) : sans cette option, la borne de 1200 px laisse une marge nue de chaque côté. */}
      <Stack.Screen name="Profile" options={SUR_LE_WEB ? PLEINE_LARGEUR : undefined}>
        {({ navigation }) => (
          <ProfileScreen
            onOpenSettings={() => navigation.navigate('Settings')}
            // La LISTE des notifications, comme la cloche de l'accueil — pas les préférences.
            onOpenNotifications={() => navigation.navigate('Notifications')}
            onOpenPersonalInfo={() => navigation.navigate('PersonalInfo')}
            // Coaching vit à la racine, hors des onglets : deux niveaux au-dessus de cette pile.
            onOpenCoaching={() => navigation.getParent()?.getParent()?.navigate('Coaching')}
            onOpenHelp={() => navigation.navigate('Help')}
          />
        )}
      </Stack.Screen>
      <Stack.Screen name="Notifications">
        {({ navigation }) => <NotificationsScreen onBack={() => navigation.goBack()} />}
      </Stack.Screen>
      <Stack.Screen name="Settings" options={SUR_LE_WEB ? PLEINE_LARGEUR : undefined}>
        {({ navigation }) => (
          <SettingsScreen
            onBack={() => navigation.goBack()}
            onOpenPrivacy={() => navigation.navigate('Privacy')}
            onOpenDataDeletion={() => navigation.navigate('DataDeletion')}
            onOpenNotifications={() => navigation.navigate('NotificationsSettings')}
            onOpenAdmin={() => navigation.navigate('Admin')}
            onOpenLicenceEcole={() => navigation.navigate('LicenceEcole')}
          />
        )}
      </Stack.Screen>
      <Stack.Screen name="Admin">
        {({ navigation }) => <AdminScreen onBack={() => navigation.goBack()} />}
      </Stack.Screen>
      <Stack.Screen name="LicenceEcole">
        {({ navigation }) => <LicenceEcoleScreen onBack={() => navigation.goBack()} />}
      </Stack.Screen>
      <Stack.Screen name="PersonalInfo">
        {({ navigation }) => <PersonalInfoScreen onBack={() => navigation.goBack()} />}
      </Stack.Screen>
      <Stack.Screen name="Privacy">
        {({ navigation }) => (
          <PrivacyScreen onBack={() => navigation.goBack()} onOpenTerms={() => navigation.navigate('Terms')} />
        )}
      </Stack.Screen>
      <Stack.Screen name="Terms">
        {({ navigation }) => (
          <TermsScreen onBack={() => navigation.goBack()} onOpenPrivacy={() => navigation.navigate('Privacy')} />
        )}
      </Stack.Screen>
      <Stack.Screen name="DataDeletion">
        {({ navigation }) => <DataDeletionScreen onBack={() => navigation.goBack()} />}
      </Stack.Screen>
      <Stack.Screen name="NotificationsSettings">
        {({ navigation }) => <NotificationsSettingsScreen onBack={() => navigation.goBack()} />}
      </Stack.Screen>
      <Stack.Screen name="Help">
        {({ navigation }) => <HelpScreen onBack={() => navigation.goBack()} />}
      </Stack.Screen>
    </Stack.Navigator>
  );
}
